const LABELS: Record<string, string> = {
  pending: 'Ожидает',
  confirmed: 'Подтверждена',
  arrived: 'Машина принята',
  in_progress: 'В работе',
  completed: 'Выполнена',
  cancelled: 'Отменена',
  no_show: 'Не приехал',
};

export function statusLabel(status: string): string {
  return LABELS[status] ?? status;
}
